import {
  EXPERIENCIES_EXCLUSIVITIES_TO_REMOVE,
  RESET_EXCLUSIVITIES,
} from 'constants/exclusivity-experience';

const initialState = {
  data: [],
};

export const experienciesExclusivitiesToRemoveReducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case EXPERIENCIES_EXCLUSIVITIES_TO_REMOVE: {
      return {
        ...state,
        data: payload,
      };
    }
    case RESET_EXCLUSIVITIES: {
      return initialState;
    }
    default:
      return state;
  }
};
